import React from "react";
import ReactDOM from "react-dom";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";

import logger from "./services/logService";
import indexRoutes from "./routes/index.jsx";
import * as serviceWorker from './serviceWorker';

// import { initializeFirebase } from './push-notification';

import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/sass/light-bootstrap-dashboard.css?v=1.1.1";
import "./assets/css/demo.css";
import "./assets/css/pe-icon-7-stroke.css";

logger.init();
ReactDOM.render(
  <HashRouter>
    <Switch>
      {indexRoutes.map((prop, key) => {
        return <Route path={prop.path} component={prop.component} key={key} />;
      })}
      <Redirect to="/login" />
    </Switch>
  </HashRouter>,
  document.getElementById("root")
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
// console.log(messaging);
// initializeFirebase();


// WEBPACK FOOTER //
// ./src/index.js